module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "cart-head"
  }, [_h('div', {
    staticClass: "back"
  }, [_h('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_m(0)])]), " ", _h('div', {
    staticClass: "title"
  }, [_h('p', [_s(shopName)])]), " ", _m(1)])
}},staticRenderFns: [function (){with(this) {
  return _h('span', {
    staticClass: "text"
  }, ["返回"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "delete"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6289194e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartHeader.vue
 ** module id = 73
 ** module chunks = 1
 **/